/**
 * Epics for pages module
 */
import { map, mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { pagesService } from "../../../common/services";
import * as actionTypes from "./actionTypes";
import * as pagesActions from "./actions";

export function fetchPage(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_PAGE),
    mergeMap(({ payload }) => {
      return pagesService.getPagById(payload).pipe(
        map((res) => pagesActions.fetchPageSuccess(res.responceObject.records)),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
export function fetchPages(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_PAGES),
    mergeMap(({ payload }) => {
      return pagesService.getPages(payload).pipe(
        map((res) =>
          pagesActions.fetchPagesSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
export function savePage(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_PAGE),
    mergeMap(({ payload }) => {
      return pagesService.savePage(payload).pipe(
        map((res) => pagesActions.savePageSuccess(res.responceObject.records)),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
export function updatePageSortOrder(action$) {
  return action$.pipe(
    ofType(actionTypes.UPDATE_PAGE_SORT_ORDER),
    mergeMap(({ payload }) => {
      return pagesService.savePage(payload).pipe(
        map((res) =>
          pagesActions.updatePageSortOrderSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
export function updatePage(action$) {
  return action$.pipe(
    ofType(actionTypes.UPDATE_PAGE),
    mergeMap(({ payload }) => {
      return pagesService.updatePage(payload).pipe(
        map((res) =>
          pagesActions.updatePageSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

export function deletePage(action$) {
  return action$.pipe(
    ofType(actionTypes.DELETE_PAGE),
    mergeMap(({ payload }) => {
      return pagesService.deletePage(payload).pipe(
        map((res) => pagesActions.deletePageSuccess(payload)),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
